<template>
  <div :class="type + ' ' + props.size" class="dialog" v-if="props.modelValue" >
    <div class="dialog-mask" @click="handleMaskClick"></div>
    <div class="dialog-content">
      <div class="dialog-body">
        <slot></slot>
      </div>
      <div class="dialog-footer" v-if="props.confirmText || props.cancelText" :class="{ 'one-btn': (!props.cancelText || !props.confirmText) }">
        <button 
          v-if="props.confirmText" 
          class="btn dialog-confirm" 
          @click="handleConfirm"
        >
          {{ props.confirmText }}
        </button>
        <button 
          v-if="props.cancelText" 
          class="btn dialog-cancel" 
          @click="handleCancel"
        >
          {{ props.cancelText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue'
import { isMobile } from '@/utils'
const type = isMobile ? 'mobile' : 'pc'
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  confirmText: {
    type: String,
    default: ''
  },
  cancelText: {
    type: String,
    default: ''
  },
  size: {
    type: String,
    default: 'normal' // normal, large
  },
  maskClosable: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['update:modelValue', 'confirm', 'cancel'])

const handleConfirm = () => {
  emit('confirm')
  emit('update:modelValue', false)
}

const handleCancel = () => {
  emit('cancel')
  emit('update:modelValue', false)
}

const handleMaskClick = () => {
  if (props.maskClosable) {
    emit('update:modelValue', false)
  }
}
</script>

<style src="./pc_style.less" lang="less" scoped></style>
<style src="./mobile_style.less" lang="less" scoped></style>

